var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4752_13092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 88.9071V167.684C236 176.451 228.893 183.558 220.127 183.558H204.92V209.066L180.367 183.558H81.8349C73.068 183.558 65.9609 176.451 65.9609 167.684V137.459V88.9071C65.9609 80.1403 73.068 73.0332 81.8349 73.0332H170.034H220.127C228.893 73.0332 236 80.1403 236 88.9071Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.033 42.8078V73.0331H81.8344C73.0675 73.0331 65.9604 80.1402 65.9604 88.9071V137.459H55.6274L54.2609 138.881L31.074 162.967V137.459H15.8677C7.10084 137.459 0 130.352 0 121.585V42.8078C0 34.0409 7.10084 26.9338 15.8677 26.9338H154.166C162.926 26.9338 170.033 34.0409 170.033 42.8078Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.034 61.3337V73.0333H81.8352C73.0683 73.0333 65.9613 80.1404 65.9613 88.9072V137.459H55.6282L54.2617 138.881V77.2077C54.2617 68.4408 61.3688 61.3337 70.1357 61.3337H170.034Z",
    fill: "#CDCDCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4752_13092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.b47e530e1923a12806a2c90ea3d62d42.svg";
export { ForwardRef as ReactComponent };